var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { get } from "lodash";
import { withRouter } from "react-router-dom";
import Icon from "@irati/ui/src/Icon";
import SearchBar from "@irati-web/search/src/components/Popups/SearchBar";
import id from "@irati/utils/id";
import { connect } from "@irati/store/connect";
import tracking from "@irati-tracking/perks/perks";
import authentication from "@irati/auth";
import HeaderLink from "./HeaderLink";
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: false
        };
        _this.handleSearch = function () {
            var show = _this.state.show;
            var query = get(_this.props.match, "path", "");
            if (query !== "/search") {
                if (!show) {
                    tracking.startSearch();
                }
                _this.setState({ show: !show });
            }
            else {
                tracking.startSearch();
                var searchResultsInput = _this.props.search.searchResultsInput;
                if (searchResultsInput) {
                    searchResultsInput.focus();
                }
            }
        };
        return _this;
    }
    Search.prototype.render = function () {
        var show = this.state.show;
        var _a = this.context, apps = _a.apps, appPath = _a.appPath;
        var isLoggedIn = authentication.isLoggedIn();
        var shouldShow = appPath === apps.PERKS || appPath === apps.SEARCH || appPath === apps.WALLET;
        if (!isLoggedIn || !shouldShow) {
            return null;
        }
        // This will be used when we get mobile designs
        var showText = false;
        var idNamespace = id("search", this.props);
        var idLink = id("link-search", idNamespace);
        return (React.createElement("div", { id: idNamespace, className: this.props.className },
            React.createElement(HeaderLink, { marginRight: true, id: idLink, onClick: this.handleSearch },
                React.createElement(Icon, { id: id("icon", idLink), icon: "search", size: 20 }),
                showText && "Search"),
            React.createElement(SearchBar, { id: idNamespace, show: show, onClose: this.handleSearch })));
    };
    Search.defaultProps = {
        match: {},
        search: {}
    };
    Search.contextTypes = {
        appPath: PropTypes.string.isRequired,
        apps: PropTypes.object.isRequired
    };
    return Search;
}(Component));
/**
 * Add Redux state & export
 */
var mapStateToProps = function (_a) {
    var search = _a.search;
    return ({ search: search });
};
export default connect(mapStateToProps)(withRouter(styled(Search)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])))));
var templateObject_1;
